<template>
  <div >
    <div class="flex header">
      <div class="max-frai">
        <img src="@/assets/images/max-frai.svg" class="w-full" alt="" />
        <p
          class="uppercase inter font-bold mt-4 fz-10"
          style="color: #ff2e53; letter-spacing: 1rem"
        >
          {{ text.AGENCY }}
        </p>
      </div>
      <div
        class="close ml-auto flex flex-col items-center cursor-pointer"
        @click="toggleContacts"
      >
        <p class="fz-10 uppercase" style="letter-spacing: 0.3rem">
          {{ text.close }}
        </p>
        <div class="close w-5 h-5 relative mt-4">
          <div
            class="w-5 h-0.5 absolute left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2 rotate-45"
            style="background: white"
          ></div>
          <div
            class="w-5 h-0.5 absolute left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2 -rotate-45"
            style="background: white"
          ></div>
        </div>
      </div>
    </div>
    <div class="mt-12.5 w-145 overflow-auto">
      <div class="flex flex-col">
        <div class="flex flex-col">
          <h4 class="uppercase mb-5 fz-201 font-medium">
            {{ text.clicks }}
          </h4>
          <div class="flex flex-wrap gap-3 mb-10">
            <div
              class="chosen-services w-max flex items-center py-4 px-7.5 rounded-full border"
              v-for="item in services"
              :key="item.id"
            >
              <p class="cursor-default font-semibold fz-13 uppercase">
                {{ item }}
              </p>
              <div
                class="ml-5 relative cursor-pointer"
                @click="deleteService(item)"
              >
                <div
                  class="w-4 h-0.5 transform rotate-45 -translate-x-1/2 bg-white absolute"
                ></div>
                <div
                  class="w-4 h-0.5 transform -rotate-45 -translate-x-1/2 bg-white absolute"
                ></div>
              </div>
            </div>
          </div>

        </div>
        <div class="flex flex-col mt-0.25">
          <div>
            <div class="field flex flex-col mb-8">
              <label for="name" class="fz-13 font-semibold uppercase mb-2.5"
                >{{ text.form.name }}</label
              >
              <input
                v-model="name"
                id="name"
                type="text"
                class="h-15 pl-4"
                :class="{ error: activeErrors.indexOf(0) !== -1 }"
              />
            </div>

            <div class="field flex flex-col mb-8">
              <label for="number" class="fz-13 font-semibold uppercase mb-2.5"
                >{{ text.form.phone }}</label
              >
              <input
                v-model="phone"
                id="number"
                @keydown.prevent="inputPhone($event)"
                :class="{
                  error:
                    activeErrors.indexOf(1) !== -1 &&
                    activeErrors.indexOf(99) !== -1,
                }"
                type="tel"
                class="h-15 pl-4"
              />
            </div>

            <div class="field flex flex-col mb-8">
              <label for="email" class="fz-13 font-semibold uppercase mb-2.5"
                >{{ text.form.email }}</label
              >
              <input
                @keypress.prevent="inputEmail($event)"
                v-model="email"
                id="email"
                type="email"
                class="h-15 pl-4"
                :class="{
                  error:
                    activeErrors.indexOf(1) !== -1 &&
                    activeErrors.indexOf(88) !== -1,
                }"
              />
            </div>

            <p class="fz-18 font-medium" style="color: rgb(110, 117, 141)">
              {{ text.form.format }}
            </p>

            <div class="flex mt-6 w-full justify-between">
              <p
                @click="toggleFormat('phone')"
                :class="{ active: activeFormats.indexOf('phone') !== -1 }"
                class="connection-format cursor-pointer font-semibold fz-13 uppercase py-4 px-7.5 rounded-full border"
              >
                {{ text.form.formats[0] }}
              </p>
              <p
                @click="toggleFormat('email')"
                :class="{ active: activeFormats.indexOf('email') !== -1 }"
                class="connection-format cursor-pointer font-semibold fz-13 uppercase py-4 px-7.5 rounded-full border"
              >
                {{ text.form.formats[1] }}
              </p>
              <p
                @click="toggleFormat('telegram')"
                :class="{ active: activeFormats.indexOf('telegram') !== -1 }"
                class="connection-format cursor-pointer font-semibold fz-13 uppercase py-4 px-7.5 rounded-full border"
              >
                {{ text.form.formats[2] }}
              </p>
              <p
                @click="toggleFormat('whatsapp')"
                :class="{ active: activeFormats.indexOf('whatsapp') !== -1 }"
                class="connection-format cursor-pointer font-semibold fz-13 uppercase py-4 px-7.5 rounded-full border"
              >
                {{ text.form.formats[3] }}
              </p>
            </div>

            <div class="mt-6 relative" style="z-index: 2">
              <p
                class="mb-2 fz-12"
                style="color: rgba(255, 46, 83, 1)"
                v-for="error in activeErrors"
                :key="error.id"
              >
                {{ text.errors[error] }}
              </p>
            </div>
            <button
              @click="sendForm()"
              class="mt-11 become-client cursor-pointer"
              style="z-index: 2"
            >
              <div
                class="connect-content flex relative justify-start items-center"
                style="z-index: 2"
              >
                <div class="plus w-12.5 h-12.5 rounded-full mr-5 relative">
                  <div
                    class="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-4 h-2px"
                  ></div>
                  <div
                    class="absolute top-1/2 left-1/2 transform rotate-90 -translate-x-1/2 -translate-y-1/2 w-4 h-2px"
                  ></div>
                </div>
                <p class="uppercase font-semibold fz-13">{{ text.form.send }}</p>
              </div>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {mapMutations} from "vuex";

export default {
  name: "contactSecond",
  props: ["choice", "text"],
  data() {
    return {
      activeFormats: [],
      services: [],
      name: "",
      phone: "+38 (0__) ___ - __ - __",
      phoneIndexes: ["+38 (0__) ___ - __ - __"],
      phoneActive: 0,
      email: "",
      activeErrors: [],
    };
  },
  mounted() {
    this.services = this.choice;
  },
  methods: {
    ...mapMutations(['toggleContacts']),
    deleteService(service) {
      if (this.services.length <= 1) {
        return;
      }
      this.services = this.services.filter((item) => item !== service);
    },
    sendForm() {
      this.activeErrors = [];
      if (this.name === "") {
        this.activeErrors.push(0);
      }
      if (this.phone !== this.phoneIndexes[9]) {
        if (
          this.activeFormats.indexOf("phone") !== -1 ||
          this.activeFormats.indexOf("telegram") !== -1 ||
          this.activeFormats.indexOf("whatsapp") !== -1
        ) {
          this.activeErrors.push(1, 99);
        }
      }
      if (
        this.email === "" ||
        !/^(([^<>()\\[\]\\.,;:\s@"]+(\.[^<>()\\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
          this.email
        )
      ) {
        if (this.activeFormats.indexOf("email") !== -1) {
          if (this.activeErrors.indexOf(1) === -1) {
            this.activeErrors.push(1, 88);
          } else {
            this.activeErrors.push(88);
          }
        }
      }
      if (
        this.phone !== this.phoneIndexes[9] &&
        this.email === "" &&
        this.activeErrors.indexOf(1) === -1
      ) {
        this.activeErrors.push(1, 99, 88);
      }
      if (this.activeFormats.length === 0) {
        this.activeErrors.push(2);
      }
      if (this.activeErrors.length > 0) {
        return;
      }
    },
    inputPhone(e) {
      if (e.key.match(/[0-9]/) && this.phoneIndexes.length < 10) {
        this.phone = this.phone.replace("_", e.key);
        if (this.phoneIndexes.length < 9) {
          this.phoneIndexes.push(this.phone);
        }
        return;
      }
      if (e.key === "Backspace") {
        if (this.phoneIndexes.length === 1) {
          this.phone = this.phoneIndexes[0];
          return;
        }
        this.phone = this.phoneIndexes.pop();
      }
    },
    inputEmail(e) {
      if (e.key.match(/[A-Za-z0-9@.]/)) {
        this.email = this.email + e.key;
      }
    },
    toggleFormat(format) {
      if (this.activeFormats.indexOf(format) !== -1) {
        this.activeFormats = this.activeFormats.filter(
          (item) => item !== format
        );
      } else {
        this.activeFormats.push(format);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
input {
  background: rgba(2, 3, 6, 0.1);
  border: 0;
  border-bottom: 1px solid #6e758d;
}
input.error {
  border-bottom: 1px solid #f22959;
}
textarea:focus,
input:focus {
  outline: none;
}
.connection-format,
.chosen-services {
  transition: all 0.3s linear;
  border-color: rgba(151, 163, 203, 0.3);
}
.connection-format:hover {
  background: rgba(151, 163, 203, 0.5);
}
.connection-format.active {
  background: rgba(151, 163, 203, 0.5);
}
</style>
